import React from "react";
import axios from "axios";
import uuidv1 from "uuid/v1";
import { pedirPermissaoParaReceberNotificacoes } from "./../../push-notification";
//import { pedirPermissaoParaReceberNotificacoes } from "../../push-notification";
//import '../../assets/style/style.css';
import "./style.css";
require("dotenv").config();
const url = process.env.REACT_APP_API_APPV1;
class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: "",
      password: "",
      id: ""
    };
  }
  handleChange = e => {
    const key = e.target.name;
    const value = e.target.value;
    this.setState({
      [key]: value
    });
    if (key === "user") {
      this.setState({
        Muser: ""
      });
    }
    if (key === "password") {
      this.setState({
        Mpassword: ""
      });
    }
  };

  login = e => {
    e.preventDefault();
    let user = this.state.user;
    let password = this.state.password;

    if (user && password) {
      axios
        .post(
          //"http://noc.all.com.br/ldapapi_app_atividade/index.php",
          url + "/logarEquipamento",

          {
            login: user,
            password: password
          },
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8"
            }
          }
        )
        .then(response => {
          if (response.data[0].status === "sucesso") {
            localStorage.setItem("uuid", uuidv1());
            localStorage.setItem("user", response.data[0].usuario);
            localStorage.setItem("token", response.data[0].token);
            localStorage.setItem("name", response.data[0].nome);
            pedirPermissaoParaReceberNotificacoes();
            this.props.history.push("/task");
          } else {
            this.setState({
              msgLogin: "Usuário ou Senha inválidos!"
            });
          }
        });
    } else {
      if (!user) {
        this.setState({
          Muser: "alert_branco"
        });
      }
      if (!password) {
        this.setState({
          Mpassword: "alert_branco"
        });
      }
    }
  };

  render() {
    return (
      <form onSubmit={e => this.login(e)}>
        <div className="container-fluid container_body container_center centerContent">
          <div className="row">
            <div className="col-sm-9 col-md-7 col-lg-5 mx-auto">
              <div className="  my-5">
                <div className="card-body ">
                  <center>
                    <img
                      src="https://viabilidades.all.com.br/imagens/allnet-logo.png"
                      alt="logo"
                    />

                    <h5 className="card-title text-center colorSubTitle margingTop20">
                      Faça login para acessar sua conta e visualizar suas
                      tarefas.
                    </h5>
                  </center>
                  <div className="form-signin maginTop18">
                    <div className="form-label-group">
                      <input
                        type="text"
                        id="inputEmail"
                        className={`form-control ${this.state.Muser}`}
                        placeholder="usuario"
                        required
                        autoFocus
                        name="user"
                        onChange={this.handleChange.bind(this)}
                        value={this.state.user}
                      />
                      <label htmlFor="inputEmail">Usuário</label>
                    </div>

                    <div className="form-label-group">
                      <input
                        type="password"
                        id="inputPassword"
                        className={`form-control ${this.state.Mpassword}`}
                        placeholder="Password"
                        required
                        name="password"
                        onChange={this.handleChange.bind(this)}
                        //value={this.state.password}
                        current-password="true"
                      />
                      <label htmlFor="inputPassword">Senha</label>
                    </div>
                    <div className="form-label-group">
                      {this.state.msgLogin}
                    </div>

                    <button
                      type="submit"
                      className="btn btn-lg btn-primary btn-block text-uppercase"
                    >
                      Entrar
                    </button>
                    <center>
                      <sub>Versão Beta 1.0</sub>
                    </center>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

export default Login;
